import ConnectWallet from "../components/sections/connectWallet";

// src/pages/ConnectWalletPage.js
function ConnectWalletPage() {
    return (
      <ConnectWallet />
    );
  }
  
  export default ConnectWalletPage;